export enum YotiFlowType {
  AGE_VERIFICATION = 'age_verification',
  HIDDEN_IMAGES = 'hidden_images',
  NONE = 'none'
}
